import styled from 'styled-components';

export const SectionContainer = styled.section`
  width: 350px;
  padding: 20px;
  text-align: center;
  background: #fff;
  border: solid black;
  border-width: 3px 3px 5px 5px;
  border-radius: 4% 95% 6% 95%/95% 4% 92% 5%;
  transform: rotate(-2deg);
`;
export const Title = styled.h2`
  font-size: 34px;
  letter-spacing: 2px;
  margin-bottom: 30px;
  color: #034f84;
`;
